/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * LeftRail.tsx — Lef\1 \2ail (services/operator-web-app).
 */

import { NavLink } from 'react-router-dom';
import { useTranslation } from '@/i18n';

const NAV_ITEMS = [
  { to: '/', labelKey: 'nav.live_calls', end: true },
  { to: '/history', labelKey: 'nav.history', end: false },
  { to: '/knowledge', labelKey: 'nav.knowledge', end: false },
  { to: '/settings', labelKey: 'nav.settings', end: false },
  { to: '/login', labelKey: 'nav.login', end: false },
] as const;

/**
 * LeftRail: queue, nav (Live Calls, History, Knowledge, Settings).
 * Plan: 02 — task-first; 14 wireframes. Collapsible on small viewports.
 */
export function LeftRail() {
  const t = useTranslation();
  return (
    <aside
      className="glass-panel hidden lg:flex flex-col w-56 xl:w-64 flex-shrink-0 overflow-hidden"
      style={{ borderRadius: 0, borderTop: 'none', borderBottom: 'none', borderLeft: 'none' }}
      aria-label={t('nav.rail_label')}
    >
      <nav className="p-2 flex flex-col gap-0.5" aria-label={t('nav.primary_label')}>
        {NAV_ITEMS.map(({ to, labelKey, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 ${
                isActive
                  ? 'bg-emerald-500/20 text-emerald-300'
                  : 'hover:bg-white/5 hover:text-slate-200'
              }`
            }
            style={({ isActive }) => (isActive ? {} : { color: 'var(--text-muted)' })}
          >
            {t(labelKey)}
          </NavLink>
        ))}
      </nav>
      <div className="mt-4 px-3 py-2 border-t border-white/10">
        <p className="text-xs font-medium" style={{ color: 'var(--text-muted)' }}>
          {t('nav.queue')}
        </p>
        <p className="text-sm mt-0.5" style={{ color: 'var(--text-secondary)' }}>
          —
        </p>
      </div>
    </aside>
  );
}
